import { endpoint } from '@/services/api/endpoint';

import {
  DocumentVendorQuerySchema,
  DocumentVendorResponseSchema,
  JEIndexFormQuerySchema,
  JEIndexFormSchema,
  JournalCellOptionsQuerySchema,
  JournalCellOptionsResponseSchema,
} from '@/domain/journal/schemas';

export const journalApi = {
  getCellOptions: endpoint({
    method: 'GET',
    url: 'getJournalEntryList',
    query: JournalCellOptionsQuerySchema,
    response: JournalCellOptionsResponseSchema,
  }),

  getDocumentVendor: endpoint({
    method: 'GET',
    url: 'getDocumentVendor',
    query: DocumentVendorQuerySchema,
    response: DocumentVendorResponseSchema,
  }),

  getIndexForm: endpoint({
    method: 'GET',
    url: 'indexForm',
    query: JEIndexFormQuerySchema,
    response: JEIndexFormSchema,
  }),
};
